import { CHANGE_SELECTED_SHOP } from './actionTypes';


export const changeSelectedShop = (data) => ({
    type: CHANGE_SELECTED_SHOP,
    payload: data
})
